import classes from "./AccordionItemContent.module.scss";

interface Props {
  children: JSX.Element;
  value?: string;
  className?: string;
}

export function AccordionItemContent({ children, value, className }: Props) {
  return (
    <>
      <div
        className={
          value === "PickUp"
            ? `${classes["accordion-item-content-pickup"]} ${className}`
            : `${classes["accordion-item-content"]} ${className}`
        }
      >
        {children}
      </div>
    </>
  );
}
